export interface BreadcrumbItem {
  label: string;
  path: string | null; // null = current page (not a link)
}

const PATH_LABELS: Record<string, string> = {
  home: 'Dashboard',
  releases: 'Última Hora',
  reports: 'Reportes',
  newsletters: 'Publicaciones',
  banners: 'Banners',
  videos: 'Videos',
  podcasts: 'Audios',
  galleries: 'Galerías',
  'critical-standars': 'Estándares Críticos',
  policies: 'Políticas',
  links: 'Enlaces',
  campaigns: 'Campañas',
  users: 'Usuarios',
  'admin-users': 'Usuarios Admin',
  roles: 'Roles',
  statistics: 'Estadísticas',
  'report-by-filter': 'Reporte por filtros',
  'report-by-employee': 'Reporte por empleado',
  'report-users-logged': 'Usuarios que han ingresado',
  'admin-logs': 'Logs de Administradores',
};

export function buildBreadcrumb(pathname: string): BreadcrumbItem[] {
  const withoutPrefix = pathname.replace(/^\/dashboard\/?/, '');
  const segments = withoutPrefix.split('/').filter(Boolean);

  if (segments.length === 0) {
    return [{ label: 'Dashboard', path: null }];
  }

  const items: BreadcrumbItem[] = [
    { label: 'Dashboard', path: '/dashboard/home' },
  ];

  let cumulativePath = '/dashboard';
  const knownSegments: Array<{ label: string; path: string }> = [];

  for (const segment of segments) {
    cumulativePath += `/${segment}`;
    const label = PATH_LABELS[segment];
    if (label) {
      knownSegments.push({ label, path: cumulativePath });
    }
  }

  knownSegments.forEach(({ label, path }, idx) => {
    const isLast = idx === knownSegments.length - 1;
    items.push({ label, path: isLast ? null : path });
  });

  return items;
}
